import React from 'react';
import { RenderBatchSectionType } from '../../Types/ForwardingBatchTypes';
import { BatchMailItemEntries } from './BatchMailItemEntries';

function BatchMailItemsComplete(props: RenderBatchSectionType) {
	return (
		<div>
			<h5 className='mb-xs'>
				{props.complete ? props.section.name : `Step ${props.sectionIndex}: ${props.section.name}`}
			</h5>

			<div className='mb-md'>
				<BatchMailItemEntries {...props} removeMailItemCallback={() => null} />
			</div>
		</div>
	);
}

export { BatchMailItemsComplete };
